import React from 'react';
//ui library
import {Container, Grid} from '@material-ui/core';
//components
import MyNextMeetingWidget from '../../../components/dashboard/my-next-meeting-widget';
import MyMeetingsWidget from '../../../components/dashboard/my-meetings-widget';
import MyNextEventWidget from '../../../components/dashboard/my-next-event-widget';
import MyEventsWidget from '../../../components/dashboard/my-events-widget';
import MyCompetitionsWidget from '../../../components/dashboard/my-competitions-widget';
import PageHeading from '../../../components/page-heading';

const DashboardView = (props) => {
  const {
    isLoading,
    myMeetings,
    showEvents,
    showGroups,
    myEvents,
    myCompetitions,
    showMatchplay
  } = props;

  return (
    <Container maxWidth={'md'}>
      <PageHeading heading={'Dashboard'}/>

      <Grid container spacing={2}>
        {
          showGroups.current &&
          <Grid item xs={12} sm={5}>
            <MyNextMeetingWidget
              isLoading={isLoading}
              myMeetings={myMeetings}/>
          </Grid>
        }

        {
          showGroups.current &&
          <Grid item xs={12} sm={7}>
            <MyMeetingsWidget
              isLoading={isLoading}
              myMeetings={myMeetings}/>
          </Grid>
        }

        {
          showEvents.current &&
          <Grid item xs={12} sm={5}>
            <MyNextEventWidget
              isLoading={isLoading}
              myEvents={myEvents}/>
          </Grid>
        }

        {
          showEvents.current &&
          <Grid item xs={12} sm={7}>
            <MyEventsWidget
              isLoading={isLoading}
              myEvents={myEvents}/>
          </Grid>
        }

        {
          showMatchplay.current &&
          <Grid item xs={12} sm={7}>
            <MyCompetitionsWidget
              isLoading={isLoading}
              myCompetitions={myCompetitions}/>
          </Grid>
        }
      </Grid>
    </Container>
  );
};

export default DashboardView;
